// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__1tHzD","loaderOuter":"PageOverlayLoader_loaderOuter__3rHTG"};